var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9972 15.7499L21.9994 15.7499C22.9545 15.7581 23.7381 14.9773 23.75 14.0042L23.75 2.0063C23.7462 1.53569 23.5589 1.08617 23.2297 0.756802C22.9014 0.428269 22.4589 0.246149 21.9972 0.250071L2.00064 0.250062C1.54109 0.246149 1.09858 0.428269 0.770279 0.756802C0.441145 1.08617 0.253838 1.53569 0.250008 2.00426L0.25 13.9937C0.253838 14.4643 0.441145 14.9138 0.770279 15.2432C1.09858 15.5717 1.54109 15.7538 2.00277 15.7499H21.9972ZM21.9962 16.2499L21.9951 16.2499L21.9972 16.2499H21.9962Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0021 2.05177V2.03577H14.0021V2.05177C17.1375 2.28121 19.5642 4.89195 19.5642 8.03577C19.5642 11.1796 17.1375 13.7903 14.0021 14.0198V14.0358H10.0021V14.0198C6.86662 13.7903 4.43994 11.1796 4.43994 8.03577C4.43994 4.89195 6.86662 2.28121 10.0021 2.05177Z",
    fill: "#0165AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6021 11.4278C13.0374 10.9175 13.9962 9.55911 13.9962 8.03582C13.9962 6.51252 13.0374 5.1541 11.6021 4.64382V11.4278ZM9.20215 4.64382C7.76686 5.1541 6.80811 6.51252 6.80811 8.03582C6.80811 9.55911 7.76686 10.9175 9.20215 11.4278V4.64382ZM10.4021 13.2358C7.53027 13.2358 5.20215 10.9077 5.20215 8.03582C5.20215 5.16393 7.53027 2.83582 10.4021 2.83582C13.274 2.83582 15.6021 5.16393 15.6021 8.03582C15.6021 10.9077 13.274 13.2358 10.4021 13.2358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersIcon);
export default __webpack_public_path__ + "static/media/dinersIcon.e3c92c978c11d8feac53152843b6f4de.svg";
export { ForwardRef as ReactComponent };